app.service('brandView', function (autocompleteInfo, pageConfig ) {

	function init() {

	}
	return {
		init
	};
});
